/**
 * 지역 표기·주소 코드 — 서버 `DistrictCode`(core/search/domain) 와 같은 규칙.
 *
 * - 지역 판정은 서버가 한다: 화면은 카카오 b_code 원문(`addressCode`)을 보낸다(2026-10-11, 행정구역 개편 대응).
 *   옛 서버 호환용 `districtId` 는 b_code 앞 5자리 + `00000`(시 아래 구 주소는 구 행 = "성남시 분당구").
 * - 보이는 지역 글은 보통 "{시·도} {시군구}". 시군구 이름이 시·도 이름을 이미 담으면 시군구만:
 *   통합시 안 구 "광주 동구"(시·도 "전남광주"), 세종 "세종시"(시·도 "세종").
 */

/** 가입·정보 수정 요청에 실을 지역 값 — b_code 가 숫자 10자리가 아니면 둘 다 비운다 */
export interface AddressCodeFields {
    addressCode?: string;
    districtId?: string;
}

export const addressCodeFields = (bCode: string | null | undefined): AddressCodeFields => {
    const code: string = (bCode ?? '').trim();
    if (!/^\d{10}$/.test(code)) return {};
    return { addressCode: code, districtId: `${code.slice(0, 5)}00000` };
};

/** "{시·도} {시군구}" — 시군구가 시·도 이름을 이미 담으면 시군구만 */
export const regionLabel = (cityName: string | null | undefined, districtName: string | null | undefined): string => {
    const city: string = (cityName ?? '').trim();
    const district: string = (districtName ?? '').trim().replace(/\s+/g, ' ');
    if (!district) return city;
    if (!city) return district;
    const first: string = district.split(' ')[0];
    const alreadyNamed: boolean = first.startsWith(city) || (district.includes(' ') && city.includes(first));
    return alreadyNamed ? district : `${city} ${district}`;
};
